import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useUserStore } from 'store/useUserStore';
import { getAuthUser } from 'store/useUserStore/selectors';

import { useToggle } from 'hooks/useToggler';

import { AuthModal } from 'interfaces/auth';

import { SectionWrapper } from 'components/_basic/SectionWrapper/SectionWrapper';
import { useAuthModalsContext } from 'components/AuthModals';
import { ChangePasswordForm } from 'components/ChangePasswordForm/ChangePasswordForm';

import styles from './AccountSettings.module.scss';

export const AccountPassword: FC = () => {
  const { t } = useTranslation();
  const [isChangePasswordModalOpened, setIsChangePasswordModalOpened] = useToggle(false);

  const { setAuthModal, setIsModalOpened, changeSetUpData } = useAuthModalsContext();
  const authUser = useUserStore(getAuthUser);

  const isRegisteredViaGrowexa = authUser?.registeredAccounts?.growexaInternal;
  const buttonText = isRegisteredViaGrowexa ? t('change') : t('setUpPassword');

  const setUpPasswordHandler = (): void => {
    setAuthModal(AuthModal.SETUP_PASSWORD);
    changeSetUpData((prev) => ({ ...prev, email: authUser?.email ?? '' }));
    setIsModalOpened(true);
  };

  const changePasswordHandler = (): void => setIsChangePasswordModalOpened(true);

  const buttonClickHandler = isRegisteredViaGrowexa ? changePasswordHandler : setUpPasswordHandler;

  return (
    <>
      <SectionWrapper sectionTitle={t('password')} buttonText={buttonText} buttonClickHandler={buttonClickHandler}>
        {!isRegisteredViaGrowexa && (
          <Box component="p" className={styles.passwordContent}>
            {t('noPasswordForAccount')}
          </Box>
        )}
      </SectionWrapper>
      <ChangePasswordForm isOpened={isChangePasswordModalOpened} handleClose={setIsChangePasswordModalOpened} />
    </>
  );
};
